"use client";
import * as e from "react";
const n = [];
function o(t) {
  e.useEffect(t, n);
}
export {
  o as u
};
